module.exports = __webpack_public_path__ + "static/media/bg_controll_btn_right.b92ee000.svg";